import { render, staticRenderFns } from "./SkeletonMedia.vue?vue&type=template&id=8246d4d4"
import script from "./SkeletonMedia.vue?vue&type=script&lang=js"
export * from "./SkeletonMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports